export default __webpack_public_path__ + "ocr-certificatesa3f835.png";